export var WidgetType;
(function (WidgetType) {
    WidgetType["WEATHER"] = "WEATHER";
    WidgetType["ALARM"] = "ALARM";
    WidgetType["MAP"] = "MAP";
    WidgetType["STATUS"] = "STATUS";
    WidgetType["TASK"] = "TASK";
    WidgetType["INVENTORY"] = "INVENTORY";
    WidgetType["LOAD_DEVIATION"] = "LOAD_DEVIATION";
    WidgetType["DELIVER_DEVIATION"] = "DELIVER_DEVIATION";
    WidgetType["DRIVE"] = "DRIVE";
})(WidgetType || (WidgetType = {}));
export var WidgetSize;
(function (WidgetSize) {
    WidgetSize["XS"] = "XS";
    WidgetSize["S"] = "S";
    WidgetSize["L"] = "L";
})(WidgetSize || (WidgetSize = {}));
export var WidgetFooterType;
(function (WidgetFooterType) {
    WidgetFooterType["VIEW_MORE"] = "VIEW_MORE";
    WidgetFooterType["EMPTY"] = "EMPTY";
})(WidgetFooterType || (WidgetFooterType = {}));
export var WidgetHeaderType;
(function (WidgetHeaderType) {
    WidgetHeaderType["GENERIC"] = "GENERIC";
})(WidgetHeaderType || (WidgetHeaderType = {}));
//# sourceMappingURL=widget.types.js.map